package com.anjuros.website.components.shared

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Circle
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px

@Composable
fun MenuIcon(
    modifier: Modifier = Modifier,
    size: Int = 24,
) {
    Svg(
        attrs = modifier
            .size(size.px)

            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "3")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
            }
    ) {
        Path(attrs = { attr("d", "M4 5h16") })
        Path(attrs = { attr("d", "M4 12h16") })
        Path(attrs = { attr("d", "M4 19h16") })
    }
}

@Composable
fun ChevronLeftIcon(
    modifier: Modifier = Modifier,
    size: Int = 48,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        Path(attrs = {
            attr("d", "M15 18l-6-6 6-6")
        })
    }
}

@Composable
fun ChevronRightIcon(
    modifier: Modifier = Modifier,
    size: Int = 48,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        Path(attrs = {
            attr("d", "M9 18l6-6-6-6")
        })
    }
}
@Composable
fun ChevronDownIcon(
    modifier: Modifier = Modifier,
    size: Int = 48,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        Path(attrs = {
            // Draws a "V" shape pointing down
            attr("d", "M6 9l6 6 6-6")
        })
    }
}
@Composable
fun FacebookSquareIcon(
    modifier: Modifier = Modifier,
    size: Int = 24,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "currentColor")
                attr("aria-hidden", "true")
            }
    ) {
        // Draw one combined path:
        // - Outer rounded square
        // - Inner "f" path
        // Use even-odd fill rule so the "f" becomes a transparent cutout.
        Path(attrs = {
            attr("fill-rule", "evenodd")
            attr("clip-rule", "evenodd")
            attr(
                "d",
                // Rounded square
                "M5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z " +
                        // Facebook "f" cutout
                        "M13.5 8H15V5.5h-1.8C10.9 5.5 10 6.9 10 8.7V10H8v2.5h2V18h3v-5.5h2.1L15.5 10H13V8.9c0-.6.2-.9.5-.9Z"
            )
        })
    }
}

@Composable
fun CircleCheckIcon(
    modifier: Modifier = Modifier,
    size: Int = 24,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        // Outer circle
        Circle(attrs = {
            attr("cx", "12")
            attr("cy", "12")
            attr("r", "10")
        })

        // Check mark
        Path(attrs = {
            attr("d", "M9 12l2 2 4-4")
        })
    }
}

@Composable
fun ListCheckIcon(
    modifier: Modifier = Modifier,
    size: Int = 24,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        // First checklist item
        Path(attrs = {
            attr("d", "M3 6l1.5 1.5L7 5")
        })
        Path(attrs = {
            attr("d", "M11 6h10")
        })

        // Second checklist item
        Path(attrs = {
            attr("d", "M3 12l1.5 1.5L7 11")
        })
        Path(attrs = {
            attr("d", "M11 12h10")
        })

        // Third checklist item
        Path(attrs = {
            attr("d", "M3 18l1.5 1.5L7 17")
        })
        Path(attrs = {
            attr("d", "M11 18h10")
        })
    }
}

@Composable
fun EyeIcon(
    modifier: Modifier = Modifier,
    size: Int = 24,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {

        // Outer eye (smoother almond shape)
        Path(attrs = {
            attr(
                "d",
                "M2 12C4.5 7 8 4.5 12 4.5C16 4.5 19.5 7 22 12C19.5 17 16 19.5 12 19.5C8 19.5 4.5 17 2 12Z"
            )
        })

        // Iris ring (matches the circular ring in the reference)
        Circle(attrs = {
            attr("cx", "12")
            attr("cy", "12")
            attr("r", "4")
        })

    }
}

@Composable
fun FaEnvelopeIcon(
    modifier: Modifier = Modifier,
    size: Int = 24,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        Path(attrs = {
            attr(
                "d",
                "M2 6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6zm2 0l8 5 8-5"
            )
            // compress height a bit
            attr("transform", "scale(1 0.85) translate(0 1.8)")
        })
    }
}

@Composable
fun FaUpRightAndDownLeftFromCenterIcon(
    modifier: Modifier = Modifier,
    size: Int = 36,
) {
    Svg(
        attrs = modifier
            .size(size.px)
            .toAttrs {
                attr("viewBox", "0 0 24 24")
                attr("fill", "none")
                attr("stroke", "currentColor")
                attr("stroke-width", "2")
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
                attr("aria-hidden", "true")
            }
    ) {
        // Arrow pointing Up-Right
        Path(attrs = {
            attr("d", "M21 3l-6.5 6.5M21 3h-6M21 3v6")
        })

        // Arrow pointing Down-Left
        Path(attrs = {
            attr("d", "M3 21l6.5-6.5M3 21h6M3 21v-6")
        })
    }
}

@Composable
fun WaveDivider(
    modifier: Modifier = Modifier.fillMaxWidth(),
    height: Int = 160,
    backgroundColor: String,
    waveColor: String,
) {
    Svg(
        attrs = modifier
            .height(height.px)
            .toAttrs {
                attr("viewBox", "0 0 1440 80")
                attr("preserveAspectRatio", "none")
                attr("aria-hidden", "true")
            }
    ) {
        Rect(attrs = {
            attr("x", "0")
            attr("y", "0")
            attr("width", "1440")
            attr("height", "80")
            attr("fill", backgroundColor)
        })

        Path(attrs = {
            attr(
                "d",
                "M0,40 " +
                        "C240,80 480,0 720,40 " +
                        "C960,80 1200,0 1440,40 " +
                        "L1440,80 " +
                        "L0,80 Z"
            )
            attr("fill", waveColor)
        })
    }
}
